var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7876 13.9276L16.8264 7.62105C16.9266 7.51747 17.0061 7.39424 17.0604 7.25846C17.1146 7.12268 17.1426 6.97704 17.1426 6.82995C17.1426 6.68286 17.1146 6.53723 17.0604 6.40145C17.0061 6.26567 16.9266 6.14243 16.8264 6.03885C16.6262 5.83133 16.3553 5.71484 16.0729 5.71484C15.7905 5.71484 15.5196 5.83133 15.3194 6.03885L9.97525 11.5543L4.68456 6.03885C4.4843 5.83133 4.2134 5.71484 3.93104 5.71484C3.64867 5.71484 3.37777 5.83133 3.17751 6.03885C3.07652 6.14205 2.99618 6.26511 2.94114 6.4009C2.8861 6.5367 2.85745 6.68253 2.85687 6.82995C2.85745 6.97737 2.8861 7.1232 2.94114 7.259C2.99618 7.3948 3.07652 7.51786 3.17751 7.62105L9.21638 13.9276C9.31647 14.0407 9.43794 14.1309 9.57315 14.1927C9.70835 14.2544 9.85436 14.2863 10.002 14.2863C10.1496 14.2863 10.2956 14.2544 10.4308 14.1927C10.566 14.1309 10.6875 14.0407 10.7876 13.9276Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.d11fb75b48fa9e7c8298ef4c53d8a7fe.svg";
export { ForwardRef as ReactComponent };